import type { SVGProps } from 'react';

const SvgFacebookColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.178 2H7.832C4.205 2 2.044 4.17 2.044 7.81v8.37c0 3.65 2.161 5.82 5.787 5.82h8.338c3.625 0 5.787-2.17 5.787-5.81V7.81C21.966 4.17 19.804 2 16.179 2Z'
      fill='#EFF0F3'
    />
    <path
      d='m12.774 8.464.038 2.212 1.972-.03c.143 0 .248.128.225.263l-.262 1.432a.24.24 0 0 1-.218.188l-1.687.03.09 5.437-2.25.038-.09-5.438-1.275.023a.221.221 0 0 1-.225-.225l-.023-1.425c0-.128.098-.225.225-.225l1.275-.023-.037-2.437a2.247 2.247 0 0 1 2.212-2.288l2.025-.03c.128 0 .225.098.225.225l.03 1.8a.221.221 0 0 1-.225.225l-1.8.03a.215.215 0 0 0-.225.218Z'
      fill='#039BE5'
    />
  </svg>
);
export default SvgFacebookColor;
